module.exports = __webpack_public_path__ + "static/media/logo_nombre.949b6baa.png";